export default __webpack_public_path__ + "static/prosandcons-1d0c57bb5cb368b2ef7ead34b29e538e.png";